import React from 'react';
import Alert from '@material-ui/lab/Alert';
import { useStyles, AlertLogic, PropTypes } from './alert.module';
import { useTranslation } from 'react-i18next';

const AlertMessage = ({ type, textKey, text }) => {
  const classes = useStyles();
  const { values } = AlertLogic({ type });
  const { t } = useTranslation();

  return (
    <Alert className={classes[values.alertClass]} severity={values.type}>
      {text ? text : t(textKey)}
    </Alert>
  );
};

AlertMessage.propTypes = {
  type: PropTypes.string,
  textKey: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), 
};

export default AlertMessage;
